var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragHolderGrayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.488,
    height: 12.977,
    viewBox: "0 0 7.488 12.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160998",
    "data-name": "Group 160998",
    transform: "translate(-768.463 -1343.098)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 1.298,
    cy: 1.298,
    rx: 1.298,
    ry: 1.298,
    transform: "translate(768.463 1343.098)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 1.298,
    cy: 1.298,
    rx: 1.298,
    ry: 1.298,
    transform: "translate(768.463 1348.288)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_285",
    "data-name": "Ellipse 285",
    cx: 1.298,
    cy: 1.298,
    rx: 1.298,
    ry: 1.298,
    transform: "translate(768.463 1353.479)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 1.298,
    cy: 1.298,
    rx: 1.298,
    ry: 1.298,
    transform: "translate(773.356 1343.098)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_282",
    "data-name": "Ellipse 282",
    cx: 1.298,
    cy: 1.298,
    rx: 1.298,
    ry: 1.298,
    transform: "translate(773.356 1348.288)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 1.298,
    cy: 1.298,
    rx: 1.298,
    ry: 1.298,
    transform: "translate(773.356 1353.479)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHolderGrayIcon);
export default __webpack_public_path__ + "static/media/drag-holder-gray-icon.5e5b223e4435bd84be30a63d1477db3f.svg";
export { ForwardRef as ReactComponent };